import TrackShell from "@/components/track/TrackShell";

export default function TrackCoachDashboard() {
  return <TrackShell roleLabel="Origin Track OS" />;
}
